import { render, staticRenderFns } from "./Customise.vue?vue&type=template&id=66e846e3"
import script from "./Customise.vue?vue&type=script&lang=js"
export * from "./Customise.vue?vue&type=script&lang=js"
import style0 from "./Customise.vue?vue&type=style&index=0&id=66e846e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports